import { DashboardCard } from '@/components/ui/dashboard-card.tsx';
// import { BatteryModuleSection } from '@/features/devices/components/BMS/battery-module-section.tsx';
import { BatteryOverviewSection } from '@/features/devices/components/BMS/battery-overview-section.tsx';
import { TemporaryReplaceModuleSection } from '@/features/devices/components/BMS/battery-module-section.tsx';

import { cn } from '@/utils/utils.ts';
import style from './battery-live-data-card.module.scss';

export function RealTimeBMSDataSection({ deviceId }: { deviceId: string | undefined }) {
  return (
    <DashboardCard className={cn('w-full overflow-hidden', style.realtime_card)}>
      <div className="h-full">
        <BatteryOverviewSection deviceId={deviceId} />
        <TemporaryReplaceModuleSection deviceId={deviceId} />
        {/*<BatteryModuleSection deviceId={deviceId} />*/}
      </div>
    </DashboardCard>
  );
}
